import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PaymentPage from "./pages/payment/PaymentPage";
import TestErrorPage from "./pages/error/TestErrorPage";
import ProdErrorPage from "./pages/error/ProdErrorPage";
import NotFoundPage from "./pages/NotFoundPage";

const AppRouter = () => {
  return (
    <Router>
      <Switch>
        <Route path="/charge/:id" component={PaymentPage} />
        <Route path="/error/:id/:code" component={TestErrorPage} />
        <Route exact path="/error" component={ProdErrorPage} />
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </Router>
  );
};

export default AppRouter;
